import $ from 'jquery';

const NS = '.mySchedule';
const OFFSET_TOP = 130;

/** Вешаем обработчики ОДИН раз (в connect). Возвращает функцию отписки для disconnect. */
export function bindScheduleUi() {
    const $btn = $('.scrollToTop');
    const $nav = $('#myScheduleBoxNav');

    $(window).on('scroll' + NS, function () {
        if ($(this).scrollTop() > OFFSET_TOP) {
            $btn.fadeIn();
            $nav.addClass('myScheduleBox__nav--scroll');
        } else {
            $btn.fadeOut();
            $nav.removeClass('myScheduleBox__nav--scroll');
        }
    });

    $btn.on('click' + NS, function () {
        $('html, body').animate({ scrollTop: 0 }, 800);
        return false;
    });

    return () => {
        $(window).off(NS);
        $btn.off(NS);
    };
}

/** Красное сообщение "заполните поле!", которое исчезает через 5 сек */
export function flashAlert($anchor, method, id, style = 'color: red;') {
    $anchor[method](`<strong id="${id}" style="${style}">заполните поле!</strong>`);
    setTimeout(() => $('#' + id).remove(), 5000);
}

function toggleDay($day) {
    if ($day.hasClass('active')) {
        $day.removeClass('active');
    } else {
        $day.addClass('active');
    }
}

export function initUiActions(){
    $(document).on('click', '.myScheduleBox__item .myScheduleBox__title', function () {
        toggleDay($(this).closest('.myScheduleBox__item'));
    });
}